"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBarBackground = _styledComponents.default.div.withConfig({
  displayName: "ProgressBar__ProgressBarBackground",
  componentId: "sc-3bd6on-0"
})(["height:3px;background-color:", ";margin:", "px 0 ", "px;display:flex;justify-content:flex-start;"], (0, _helpers.color)("black10"), (0, _helpers.space)(0.5), (0, _helpers.space)(1));
/** ProgressBar */


var ProgressBar = function ProgressBar(_ref) {
  var percentComplete = _ref.percentComplete,
      _ref$highlight = _ref.highlight,
      highlight = _ref$highlight === void 0 ? "purple100" : _ref$highlight;
  return _react.default.createElement(ProgressBarBackground, null, _react.default.createElement("div", {
    style: {
      transition: "width 0.34s ease",
      backgroundColor: (0, _helpers.color)(highlight),
      width: Math.round(percentComplete) + "%"
    }
  }));
};

exports.ProgressBar = ProgressBar;
ProgressBar.displayName = "ProgressBar";
//# sourceMappingURL=ProgressBar.js.map